import React from "react";
import { observer } from "mobx-react-lite";
import SetupStore from "../store/setupStore";
import EventStore from "../../event/store/eventStore";

interface RoundSelectorProps {
  numRounds: number;
}

const RoundSelectorComponent: React.FC<RoundSelectorProps> = ({
  numRounds,
}) => {
  if (numRounds <= 1) {
    return null;
  }

  const handleRoundSelect = async (roundNumber: number) => {
    try {
      await SetupStore.setActiveRound(roundNumber);
    } catch (error) {
      console.error("Failed to set active round:", error);
    }
  };

  const isRoundClickable = (roundNumber: number) => {
    if (roundNumber === 1) return true;

    const previousRound = EventStore.sitchEventData?.rounds?.find(
      (r) => r.round_num === roundNumber - 1,
    );
    return previousRound?.is_accepted === true;
  };

  return (
    <div className="flex flex-col items-center w-full">
      <div className="flex w-full">
        {Array.from({ length: numRounds }, (_, index) => {
          const roundNumber = index + 1;
          const isClickable = isRoundClickable(roundNumber);

          return (
            <div
              key={roundNumber}
              role="button"
              tabIndex={0}
              className={`flex flex-col items-center justify-center flex-1 px-2 ${
                SetupStore.activeRound === roundNumber ? "font-bold" : ""
              } ${isClickable ? "cursor-pointer" : "cursor-not-allowed opacity-50"}`}
              onClick={
                isClickable ? () => handleRoundSelect(roundNumber) : undefined
              }
              onKeyDown={
                isClickable
                  ? (e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        handleRoundSelect(roundNumber);
                      }
                    }
                  : undefined
              }
            >
              <h2 className="text-xl mb-2">Round {roundNumber}</h2>
              <div
                className={`w-full h-0.5 ${
                  SetupStore.activeRound === roundNumber
                    ? "bg-white/80"
                    : "bg-white/10"
                }`}
              />
            </div>
          );
        })}
      </div>
      <div className="w-full h-px bg-white/20 mt-1" />
    </div>
  );
};

const RoundSelector = observer(RoundSelectorComponent);

export default RoundSelector;
